import { render, staticRenderFns } from "./ClientJobLayout.vue?vue&type=template&id=da251522"
import script from "./ClientJobLayout.vue?vue&type=script&lang=js"
export * from "./ClientJobLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports